import { helloBabyPostPath } from 'lib/urls'
import { PrimaryButton } from 'components/buttons'
import Link from 'components/link'
import Image from 'components/image'
import { Post } from '../due-date-view'

interface PregnancyPostProps {
  post: Post
  numWeeksPregnant: number
}

const PregnancyPost = ({ post, numWeeksPregnant }: PregnancyPostProps) => (
  <div className="mbxl">
    {/* we should remove these duplicate links */}
    <Link className="text-body" url={post.socialShareUrl}>
      <Image
        alt={`${numWeeksPregnant} Weeks Pregnant Guide`}
        className="img-responsive rounded-corners"
        src={post.featuredImage?.url}
      />
      <p className="h5 mtm mbl text-center">{post.teaser}</p>
    </Link>
    <div className="text-center">
      <PrimaryButton pill className="phxl" href={post.socialShareUrl}>
        {numWeeksPregnant} Weeks Pregnant Guide
      </PrimaryButton>
      <div className="mtl h6">
        <Link url={helloBabyPostPath('pregnancy-week-by-week')}>
          View All Pregnancy Week by Weeks
        </Link>
      </div>
    </div>
  </div>
)

export default PregnancyPost
